import React from "react";
import SmsSetting from "./SmsSetting/SmsSetting";
import SmsConfig from "./SmsConfig/SmsConfig";
import { CanAccessThisPage } from "Common/RoleVerify";

const SmsSettings = () => {

    return (
        <CanAccessThisPage menu_access={["can_access", "can_edit"]}>
            <SmsSetting />
            <SmsConfig />
        </CanAccessThisPage>
    );
};

export default SmsSettings;
